import { createTheme, type MantineColorsTuple } from '@mantine/core';

/**
 * Barve in mere kot v nekdanji Swing temi (Tema.java), da je splet videti kot namizna aplikacija.
 * Nove barve dodaj sem, ne v posamezne zaslone.
 */
export const barve = {
  ozadje: 'rgb(50, 50, 100)',
  ozadjeTemno: 'rgb(32, 32, 70)',
  ozadjeStrani: 'rgb(243, 244, 249)',
  povrsinaPolje: 'rgb(246, 247, 251)',
  besedilo: 'rgb(28, 28, 52)',
  besediloSekundarno: 'rgb(107, 109, 133)',
  besediloNaOzadjuSekundarno: 'rgb(190, 192, 225)',
  obroba: 'rgb(217, 219, 232)',
  primarna: 'rgb(66, 66, 150)',
  poudarek: 'rgb(254, 215, 0)',
  izbrano: 'rgb(232, 232, 246)',
  napaka: 'rgb(200, 48, 48)',
} as const;

/** Odtenki primarne barve (Tema.PRIMARNA = indeks 6, hover 5, pritisnjena 7). */
const hera: MantineColorsTuple = [
  '#eeeef8',
  '#dcdcf0',
  '#b9b9e1',
  '#9494d0',
  '#7474c2',
  '#5050ac',
  '#424296',
  '#34347a',
  '#2a2a63',
  '#20204b',
];

export const tema = createTheme({
  primaryColor: 'hera',
  primaryShade: 6,
  colors: { hera },
  black: barve.besedilo,
  // Swing ima priloženo Helvetico; v brskalniku je ne razdeljujemo (licenca), zato sistemska Helvetica/Arial.
  fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  headings: { fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif', fontWeight: '700' },
  defaultRadius: 'md',
  radius: { md: '10px', lg: '20px' },
  components: {
    Button: { defaultProps: { size: 'md' } },
    TextInput: { defaultProps: { size: 'md' } },
    PasswordInput: { defaultProps: { size: 'md' } },
    // vsa vnosna polja enako visoka (kot Tema.VISINA_KONTROLE)
    DatePickerInput: { defaultProps: { size: 'md' } },
    Select: { defaultProps: { size: 'md' } },
    Modal: { styles: { title: { fontWeight: 700, fontSize: 18 } } },
  },
});
